import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { CircleStyleLayer as e, SymbolStyleLayer as t, LineStyleLayer as r, FillStyleLayer as s, BackgroundStyleLayer as i } from "./StyleLayer.js";

var a = /*#__PURE__*/function () {
  function a(e) {
    var _this = this;

    _classCallCheck(this, a);

    if (this._style = e, this.backgroundBucketIds = [], this._uidToLayer = new Map(), this._layerByName = {}, this._runningId = 0, e.layers || (e.layers = []), this.version = parseFloat(e.version), this.layers = e.layers.map(function (e, t, r) {
      return _this._create(e, t, r);
    }), this.layers) {
      var _e;

      for (var _t = 0; _t < this.layers.length; _t++) {
        _e = this.layers[_t], this._layerByName[_e.id] = _e, this._uidToLayer.set(_e.uid, _e), 0 === _e.type && this.backgroundBucketIds.push(_e.id);
      }
    }

    this._identifyRefLayers();
  }

  _createClass(a, [{
    key: "isPainterDataDriven",
    value: function isPainterDataDriven(e) {
      var t = this._layerByName[e];
      return !!t && t.isPainterDataDriven();
    }
  }, {
    key: "getStyleLayerId",
    value: function getStyleLayerId(e) {
      return e >= this.layers.length ? null : this.layers[e].id;
    }
  }, {
    key: "getStyleLayerByUID",
    value: function getStyleLayerByUID(e) {
      var t = this._uidToLayer.get(e);

      return null != t ? t : null;
    }
  }, {
    key: "getStyleLayerIndex",
    value: function getStyleLayerIndex(e) {
      var t = this._layerByName[e];
      return t ? this.layers.indexOf(t) : -1;
    }
  }, {
    key: "setStyleLayer",
    value: function setStyleLayer(e, t) {
      if (!e || !e.id) return;
      var r = this._style;
      null != t && t >= this.layers.length && (t = this.layers.length - 1);
      var s,
          i = !0;
      var l = this._layerByName[e.id];

      if (l) {
        var y = this.layers.indexOf(l);
        t || (t = y), t === y ? (i = !1, s = a._recreateLayer(e, l), this.layers[t] = s, r.layers[t] = e) : (this.layers.splice(y, 1), r.layers.splice(y, 1), s = this._create(e, t, this.layers), this.layers.splice(t, 0, s), r.layers.splice(t, 0, e));
      } else s = this._create(e, t, this.layers), !t || t >= this.layers.length ? (this.layers.push(s), r.layers.push(e)) : (this.layers.splice(t, 0, s), r.layers.splice(t, 0, e));

      this._layerByName[e.id] = s, this._uidToLayer.set(s.uid, s), i && this._recomputeZValues(), this._identifyRefLayers();
    }
  }, {
    key: "getStyleLayer",
    value: function getStyleLayer(e) {
      var t = this._layerByName[e];
      return t ? {
        type: t.typeName,
        id: t.id,
        source: t.source,
        "source-layer": t.sourceLayer,
        minzoom: t.minzoom,
        maxzoom: t.maxzoom,
        filter: t.filter,
        layout: t.layout,
        paint: t.paint
      } : null;
    }
  }, {
    key: "deleteStyleLayer",
    value: function deleteStyleLayer(e) {
      var t = this._layerByName[e];

      if (t) {
        delete this._layerByName[e], this._uidToLayer.delete(t.uid);

        var _r = this.layers.indexOf(t);

        this.layers.splice(_r, 1), this._style.layers.splice(_r, 1), this._recomputeZValues(), this._identifyRefLayers();
      }
    }
  }, {
    key: "getLayerById",
    value: function getLayerById(e) {
      return this._layerByName[e];
    }
  }, {
    key: "getLayoutProperties",
    value: function getLayoutProperties(e) {
      var t = this._layerByName[e];
      return t ? t.layout : null;
    }
  }, {
    key: "getPaintProperties",
    value: function getPaintProperties(e) {
      var t = this._layerByName[e];
      return t ? t.paint : null;
    }
  }, {
    key: "setPaintProperties",
    value: function setPaintProperties(e, t) {
      var r = this._layerByName[e];
      if (!r) return;

      var s = {
        type: r.typeName,
        id: r.id,
        source: r.source,
        "source-layer": r.sourceLayer,
        minzoom: r.minzoom,
        maxzoom: r.maxzoom,
        filter: r.filter,
        layout: r.layout,
        paint: t
      },
          i = a._recreateLayer(s, r),
          l = this.layers.indexOf(r);

      this.layers[l] = i, this._style.layers[l].paint = t, this._layerByName[r.id] = i, this._uidToLayer.set(r.uid, i);
    }
  }, {
    key: "setLayoutProperties",
    value: function setLayoutProperties(e, t) {
      var r = this._layerByName[e];
      if (!r) return;

      var s = {
        type: r.typeName,
        id: r.id,
        source: r.source,
        "source-layer": r.sourceLayer,
        minzoom: r.minzoom,
        maxzoom: r.maxzoom,
        filter: r.filter,
        layout: t,
        paint: r.paint
      },
          i = a._recreateLayer(s, r),
          l = this.layers.indexOf(r);

      this.layers[l] = i, this._style.layers[l].layout = t, this._layerByName[r.id] = i, this._uidToLayer.set(r.uid, i);
    }
  }, {
    key: "setStyleLayerVisibility",
    value: function setStyleLayerVisibility(e, t) {
      var r = this._layerByName[e];
      if (!r) return;
      var s = r.layout || {};
      s.visibility = t;

      var i = {
        type: r.typeName,
        id: r.id,
        source: r.source,
        "source-layer": r.sourceLayer,
        minzoom: r.minzoom,
        maxzoom: r.maxzoom,
        filter: r.filter,
        layout: s,
        paint: r.paint
      },
          l = a._recreateLayer(i, r),
          y = this.layers.indexOf(r);

      this.layers[y] = l, this._style.layers[y].layout = s, this._layerByName[r.id] = l, this._uidToLayer.set(r.uid, l);
    }
  }, {
    key: "getStyleLayerVisibility",
    value: function getStyleLayerVisibility(e) {
      var t;
      var r = this._layerByName[e];
      if (!r) return "none";
      var s = r.layout;
      return null != (t = null == s ? void 0 : s.visibility) ? t : "visible";
    }
  }, {
    key: "_recomputeZValues",
    value: function _recomputeZValues() {
      var e = this.layers,
          t = 1 / (e.length + 1);

      for (var _r2 = 0; _r2 < e.length; _r2++) {
        e[_r2].z = 1 - (1 + _r2) * t;
      }
    }
  }, {
    key: "_identifyRefLayers",
    value: function _identifyRefLayers() {
      var e = [],
          t = [];
      var r = 0;

      var _iterator = _createForOfIteratorHelper(this.layers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _a5 = _step.value;
          var l = _a5.layout;

          if (1 === _a5.type) {
            var s;
            var _t2 = _a5;

            var _i = _a5.source + "|" + _a5.sourceLayer;

            _i += null != (s = "|" + (null == l ? void 0 : l.visibility)) ? s : "", _i += "|" + _a5.minzoom, _i += "|" + _a5.maxzoom, _i += "|" + JSON.stringify(_a5.filter), (_t2.hasDataDrivenFill || _t2.hasDataDrivenOutline) && (_i += "|" + r), e.push({
              key: _i,
              layer: _a5
            });
          } else if (2 === _a5.type) {
            var i;
            var _e2 = _a5;

            var _s = _a5.source + "|" + _a5.sourceLayer;

            _s += null != (i = "|" + (null == l ? void 0 : l.visibility)) ? i : "", _s += "|" + _a5.minzoom, _s += "|" + _a5.maxzoom, _s += "|" + JSON.stringify(_a5.filter), _s += "|" + (void 0 !== l ? l["line-cap"] : ""), _s += "|" + (void 0 !== l ? l["line-join"] : ""), _e2.hasDataDrivenLine && (_s += "|" + r), t.push({
              key: _s,
              layer: _a5
            });
          }

          ++r;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._assignRefLayers(e), this._assignRefLayers(t);
    }
  }, {
    key: "_assignRefLayers",
    value: function _assignRefLayers(e) {
      var t, r;
      e.sort(function (e, t) {
        return e.key < t.key ? -1 : e.key > t.key ? 1 : 0;
      });
      var s = e.length;

      for (var _i2 = 0; _i2 < s; _i2++) {
        var _a6 = e[_i2];
        if (_a6.key === t) _a6.layer.refLayerId = r;else if (t = _a6.key, r = _a6.layer.id, 1 === _a6.layer.type) {
          if (!_a6.layer.getPaintProperty("fill-outline-color")) for (var l = _i2 + 1; l < s; l++) {
            var _s2 = e[l];
            if (_s2.key !== t) break;

            if (_s2.layer.getPaintProperty("fill-outline-color")) {
              e[_i2] = _s2, e[l] = _a6, r = _s2.layer.id;
              break;
            }
          }
        } else if (2 === _a6.layer.type) {
          var _l = _a6.layer;

          for (var y = _i2 + 1; y < s; y++) {
            var _s3 = e[y];
            if (_s3.key !== t) break;
            var n = _s3.layer;
            (_l.canUseThinTessellation && !n.canUseThinTessellation || !_l.canUseThinTessellation && (n.getPaintProperty("line-pattern") || n.getPaintProperty("line-dasharray"))) && (_l = n, e[_i2] = _s3, e[y] = _a6, r = _s3.layer.id);
          }
        }
      }
    }
  }, {
    key: "_create",
    value: function _create(_a3, l, y) {
      var n = 1 - (1 + l) * (1 / (y.length + 1)),
          o = this._runningId++;

      switch (_a3.type) {
        case "background":
          return new i(0, _a3, n, o);

        case "fill":
          return new s(1, _a3, n, o);

        case "line":
          return new r(2, _a3, n, o);

        case "symbol":
          return new t(3, _a3, n, o);

        case "raster":
          throw new Error("Unsupported vector tile raster layer");

        case "circle":
          return new e(4, _a3, n, o);
      }

      throw new Error("Unknown vector tile layer");
    }
  }], [{
    key: "_recreateLayer",
    value: function _recreateLayer(_a4, l) {
      switch (_a4.type) {
        case "background":
          return new i(0, _a4, l.z, l.uid);

        case "fill":
          return new s(1, _a4, l.z, l.uid);

        case "line":
          return new r(2, _a4, l.z, l.uid);

        case "symbol":
          return new t(3, _a4, l.z, l.uid);

        case "raster":
          throw new Error("Unsupported vector tile raster layer");

        case "circle":
          return new e(4, _a4, l.z, l.uid);
      }
    }
  }]);

  return a;
}();

export { a as default };